import { createFileRoute, Outlet, Link } from "@tanstack/react-router";
import { Phone } from "lucide-react";

import { NAP, SHOW_PHONE } from "@/lib/business";
import { FooterMinimal } from "@/components/site/Footer";

export const Route = createFileRoute("/_lp")({
  component: LpLayout,
});

function LpLayout() {
  return (
    <>
      <header className="w-full border-b border-ink-200 bg-paper-0">
        <div
          className="mx-auto flex h-[72px] w-full items-center justify-between"
          style={{ maxWidth: "1200px", paddingInline: "clamp(20px, 5vw, 48px)" }}
        >
          <Link
            to="/"
            className="inline-flex min-h-[44px] items-center font-display text-body font-semibold tracking-tight text-ink-900"
          >
            LAA Concierge Consulting
          </Link>
          {SHOW_PHONE ? (
            <a
              href={NAP.phoneHref}
              className="inline-flex min-h-[44px] items-center gap-2 font-mono text-body-sm text-ink-900 transition-brand hover:text-brand-700"
            >
              <Phone className="size-4" aria-hidden="true" />
              {NAP.phone}
            </a>
          ) : null}
        </div>
      </header>
      <main id="main">
        <Outlet />
      </main>
      <FooterMinimal />
    </>
  );
}
